// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--search-magnifier{position:absolute;z-index:2;top:50%;left:16px;width:16px;height:16px;fill:#525252;pointer-events:none;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
